<div class="one-dialog">
    <div class="dialog-header d-flex">
        <div class="title flex-grow-1">
            <h2 mat-dialog-title>{{title}}</h2>
        </div>
        <div class="right">
            <button mat-icon-button mat-dialog-close aria-label="Close dialog icon">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
    <mat-dialog-content>
      <form class="attribute-form" [formGroup]="attributeFormGroup">
        <div class="dialog-body">
            <div class="row">
                <mat-form-field class="full" appearance="fill">
                    <mat-label>Loại dữ liệu đầu vào *</mat-label>
                    <mat-select formControlName="attrType">
                        <mat-option [value]="attributeType.id" *ngFor="let attributeType of attributeTypes">
                            {{attributeType.friendlyName }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="row">
                <mat-form-field class="full" appearance="fill">
                    <mat-label>Tên trường dữ liệu</mat-label>
                    <input matInput placeholder="Tên trường dữ liệu" formControlName="attrName" required>
                    <mat-error *ngIf="formSubmitted && form.attrName.invalid">Tên trường dữ liệu không được trống</mat-error>
                </mat-form-field>
            </div>

          <div class="row" *ngIf="form.attrType.value != 9">
            <mat-form-field class="full" appearance="fill">
              <mat-label>Giải thích thêm (không bắt buộc)</mat-label>
              <textarea matInput placeholder="Giải thích thêm" formControlName="description"></textarea>
            </mat-form-field>
          </div>

            <div class="row" *ngIf="hasConfig">
                <mat-form-field class="full" appearance="fill">
                    <mat-label>{{additionDataLabel}}</mat-label>
                    <textarea matInput placeholder="{{additionalDataDes}}" formControlName="additionalData" [required]="hasConfig"></textarea>
                </mat-form-field>
                <div *ngIf="errorMessage" style="color: red;">* {{errorMessage}}</div>
            </div>

            <div class="row" *ngIf="form.attrType.value != 9">
                <mat-slide-toggle class="full" labelPosition="before" color="warn" formControlName="attrRequired">
                    Bắt buộc trả lời?
                </mat-slide-toggle>
            </div>

            <div class="row" *ngIf="otherAttributes.length > 0">
                <mat-form-field class="full" appearance="fill">
                    <mat-label>Thứ tự đứng sau?</mat-label>
                    <mat-select formControlName="attrOrder">
                        <mat-option [value]="attribute.id" *ngFor="let attribute of otherAttributes">
                            {{ attribute.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
      </form>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close>Hủy bỏ</button>
        <button mat-raised-button color="warn"
            [disabled]="form.attrName.invalid"
            (click)="closeForm()">{{saveText}}</button>
    </mat-dialog-actions>
</div>
